module.exports = __webpack_public_path__ + "static/media/18ECA43.9cc54dd0.jpg";